import React, { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';
import Incidents from './Incidents';
import IncidentDetail from './IncidentDetail';

/** Nested so `useParams()` gives the detail page both ids. No guard: the section above it is already one. */
const IncidentsRouter = (): ReactElement => (
  <Routes>
    <Route path=":productId/:incidentId" element={<IncidentDetail />} />
    <Route path="*" element={<Incidents />} />
  </Routes>
);

export default IncidentsRouter;
